import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson35: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson34"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Starchy Foods</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson36"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-gainsboro-100 font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              Starchy foods are our main source of carbohydrate and have an
              important role in a healthy diet.
            </b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Starchy foods – such as potatoes, bread, rice, pasta, and cereals –
            should make up just over a third of the food you eat.
          </p>
          <p className="m-0">
            Where you can, choose wholegrain varieties, and eat potatoes with
            their skin on for more fiber.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            We should eat some starchy foods every day as part of a healthy,
            balanced diet.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Need Of Starchy Foods</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Starchy foods are a good source of energy and the main source of
                a range of nutrients in our diet. As well as starch, they
                contain fiber, calcium, iron and B vitamins.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Some people think starchy foods are fattening, but gram for gram
                they contain fewer than half the calories of fat.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Just watch out for the added fats you use when you cook and
                serve them, because this will increase the calorie content.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>{`Starchy Foods & Fiber`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Wholegrain varieties of starchy foods and potatoes (particularly
                when eaten with their skin on) are good sources of fiber.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Fiber is the name given to a range of substances found in the
                cell walls of vegetables, fruits, pulses and cereal grains.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Fiber that cannot be digested helps other food and waste
                products to move through the gut.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Potato skins, wholegrain bread and breakfast cereals, brown
                rice, and wholewheat pasta are all good sources of this kind of
                fiber.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Fiber can help keep your bowels healthy and can help you feel
                full, which means you're less likely to eat too much.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                This makes wholegrain starchy foods and potatoes eaten with
                their skin on a particularly good choice if you're trying to
                lose weight.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Some types of fiber found in fruits and vegetables – such as
                apples, carrots, potatoes – and in oats and pulses can be partly
                digested and may help reduce the amount of cholesterol in your
                blood.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[54.31rem] object-cover"
          alt=""
          src="/216@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Breakfast</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.5rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Choose wholegrain cereals, or mix some in with your favorite
                  healthy breakfast cereals.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Plain porridge with fruit makes a warming winter breakfast.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Whole oats with fruit and low-fat, lower-sugar yogurt makes a
                  tasty summer breakfast.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>{`Lunch & Dinner`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.5rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Try a baked potato for lunch – eat the skin for even more
                  fiber.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Instead of having chips or frying potatoes, try making
                  oven-baked potato wedges.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Have more rice or pasta and less sauce – but do not skip the
                  vegetables.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Try breads such as seeded, wholemeal or granary. When you
                  choose wholegrain varieties, you'll also increase the amount
                  of fiber you're eating.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>Try brown rice – it makes a very tasty rice salad.</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>
              <span>Types of Starchy Foods</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-white">
            <b>
              <span>{`Potatoes `}</span>
            </b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Potatoes are a great choice of starchy food and a good source of
            energy, fiber, B vitamins and potassium.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            In the UK, we also get a lot of our vitamin C from potatoes.
            Although potatoes only contain a small amount of vitamin C, we
            generally eat a lot of them. They're good value for money and can be
            a healthy choice.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Although potatoes are a vegetable, in the UK we mostly eat them as
            the starchy food part of a meal, and they're a good source of
            carbohydrate in our diet.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Because of this, potatoes do not count towards your five portions of
            fruit and vegetables a day, but they can have an important role in
            your diet.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Potatoes are a healthy choice when boiled, baked, mashed or roasted
            with only a small amount of fat or oil and no added salt.
          </p>
          <p className="m-0">
            French fries and other chips cooked in oil or served with salt are
            not a healthy choice.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            When cooking or serving potatoes, go for lower-fat or
            polyunsaturated spreads, or small amounts of unsaturated oils, such
            as olive or sunflower oil.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            For mashed potato, use lower-fat milk, such as semi-skimmed, 1% fat
            or skimmed milk, instead of whole milk or cream.
          </p>
          <p className="m-0">
            Leave potato skins on where possible, to keep more of the fiber and
            vitamins. For example, eat the skin when you have boiled or baked
            potatoes.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If you boil potatoes, some nutrients will leak out into the water,
            especially if you have peeled them. To stop this happening, only use
            enough water to cover them and cook them only for as long as they
            need.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Storing potatoes in a cool, dark and dry place or in the fridge will
            help stop them sprouting. Do not eat any green, damaged or sprouting
            bits of potatoes, as these can contain toxins that can be harmful.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Bread</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Bread, especially wholemeal, granary, brown and seeded varieties, is
            a healthy choice to eat as part of a balanced diet.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Wholegrain, wholemeal and brown breads give us energy and contain B
            vitamins, vitamin E, fiber and a wide range of minerals.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            White bread also contains a range of vitamins and minerals, but it
            has less fiber than wholegrain, wholemeal or brown bread. If you
            prefer white bread, look for higher-fiber options.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Some people avoid bread because they're concerned about having a
            food intolerance or allergy to wheat, or they think bread is
            fattening.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            However, completely cutting out any type of food from your diet
            could mean you miss out on a range of nutrients that you need to
            stay healthy.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If you're concerned that you have a wheat allergy or intolerance,
            speak to a GP.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Bread can be stored at room temperature. Follow the "best before"
            date to make sure you eat it fresh.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Cereal Products</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">{`Cereal products are made from grains. Wholegrain cereals can contribute to our daily intake of iron, fiber, B vitamins and protein. `}</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Higher-fiber options can also provide a slow release of energy.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Wheat, oats, barley, rye and rice are commonly available cereals
            that can be eaten as wholegrains.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            This means cereal products consisting of oats or oatmeal, such as
            porridge, and wholewheat products are healthy breakfast options.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Barley, couscous, corn and tapioca also count as healthy cereal
            products.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Many cereal products in the UK are refined, with low wholegrain
            content. They can also be high in added salt and sugar.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            When you're shopping for cereals, check the food labels to compare
            different products.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Cereal Products</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">{`Cereal products are made from grains. Wholegrain cereals can contribute to our daily intake of iron, fiber, B vitamins and protein. `}</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Higher-fiber options can also provide a slow release of energy.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Wheat, oats, barley, rye and rice are commonly available cereals
            that can be eaten as wholegrains.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            This means cereal products consisting of oats or oatmeal, such as
            porridge, and wholewheat products are healthy breakfast options.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Barley, couscous, corn and tapioca also count as healthy cereal
            products.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Many cereal products in the UK are refined, with low wholegrain
            content. They can also be high in added salt and sugar.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            When you're shopping for cereals, check the food labels to compare
            different products.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>{`Rice & Grains`}</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Rice and grains are an excellent choice of starchy food. They give
            us energy, are low in fat, and good value for money.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">There are many types to choose from, including:</p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1.5rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                All kinds of rice – such as quick-cook, arborio, basmati, long
                grain, brown, short grain and wild
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>Couscous</span>
            </li>
            <li className="mb-[0rem]">
              <span>Bulgur wheat</span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            As well as carbohydrates, rice and grains (particularly brown and
            wholegrain varieties) can contain:
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                Fibre, which can help your body get rid of waste products
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                B vitamins, which help release energy from the food you eat and
                help your body work properly
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Rice and grains, such as couscous and bulgur wheat, can be eaten hot
            or cold, and in salads.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            There are a few precautions you should take when storing and
            reheating cooked rice and grains. This is because the spores of some
            food poisoning bugs can survive cooking.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If cooked rice or grains are left standing at room temperature, the
            spores can germinate. The bacteria multiply and produce toxins that
            make you be sick (vomit) and have diarrhoea. Reheating food will not
            get rid of these toxins.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            It's therefore best to serve rice and grains as soon as they have
            been cooked. If this is not possible, cool them within 1 hour of
            cooking and keep them refrigerated until you reheat them or use them
            in a recipe such as a salad.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            It's important to throw away any rice and grains that have been left
            at room temperature overnight.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If you are not going to eat cooked rice immediately, refrigerate it
            within 1 hour and eat it within 24 hours.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Rice should be reheated thoroughly, reaching a core temperature of
            70C for 2 minutes (or equivalent) so it's steaming hot throughout.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Rice should not be reheated more than once – it should be thrown
            away. Do not reheat rice unless it's been chilled safely and kept in
            a fridge until you reheat it.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Follow the "use by" date and storage instructions on the label for
            any cold rice or grain salads that you buy.
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[61.19rem] object-cover"
          alt=""
          src="/217@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Pasta</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Pasta is another healthy option to base your meal on. It
                consists of dough made from durum wheat and water and contains
                iron and B vitamins.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Wholewheat or wholegrain are healthier than ordinary pasta, as
                they contain more fibre. We digest wholegrain foods slower than
                refined grains, so they can help us feel full for longer.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Dried pasta can be stored in a cupboard and typically has a long
                shelf life, while fresh pasta will need to be refrigerated and
                has a shorter lifespan.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Check the food packaging for "best before" or "use by" dates and
                further storage instructions.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[63.56rem] object-cover"
          alt=""
          src="/218@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Acrylamide</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Acrylamide is a chemical that's created when many foods,
                particularly starchy foods like potatoes and bread, are cooked
                for long periods at high temperatures, such as when baking,
                frying, grilling, toasting and roasting.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>There's evidence to show acrylamide can cause cancer.</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The Food Standards Agency has these tips to reduce your risk of
                acrylamide at home:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Go for gold: aim for a golden yellow colour, or lighter, when
                  baking, toasting, roasting or frying starchy foods like
                  potatoes, root vegetables and bread.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Check the pack: follow the cooking instructions carefully when
                  frying or oven-heating packaged food products such as chips,
                  roast potatoes and parsnips. These instructions are to help
                  you cook the product correctly, so you do not cook starchy
                  foods for too long or at temperatures that are too high.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Eat a varied and balanced diet: while we cannot completely
                  avoid risks like acrylamide in food, this will help reduce
                  your risk of cancer. This includes basing meals on starchy
                  carbohydrates and getting your 5 A Day. Avoid frying or
                  roasting potatoes and root vegetables. Instead, boil or steam
                  them as this will both reduce your risk of acrylamide and cut
                  down on fat.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson36"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson35;
